<!-- 
Displays a warning that the UI is out of sync with the API.
-->
<template>
  <v-snackbar 
    :value="show" :multi-line="true" :timeout="0"
    bottom left color="info"
  >
    A new version of LTPS is available. Reload to update.
    <v-btn flat @click="reload">
      Reload
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  computed: {
    show() {
      return this.$store.getters.clientOutOfDate;
    }
  },
  methods: {
    reload() {
      window.location.reload(true);
    }
  }
};
</script>
